import axios from 'axios'
import { apiBaseUrl } from '../const'
import { forceLogout, getActiveToken, isTokenExpired, isLoginRequest, isRefreshTokenRequest } from './forceLogout'
import { refreshActiveToken } from './tokenRefresh'

export { getActiveToken, isLoginRequest } from './forceLogout'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_ADMIN_API_BASE_URL || apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    Accept: '*/*',
  },
})

apiClient.interceptors.request.use(
  async (config) => {
    let token = getActiveToken()
    const requestUrl = config.url ?? ''
    if (token) {
      if (!isLoginRequest(requestUrl) && !isRefreshTokenRequest(requestUrl) && isTokenExpired(token)) {
        token = await refreshActiveToken()
        if (!token) {
          forceLogout()
          return Promise.reject(new Error('Token expired'))
        }
      }
      config.headers.Authorization = `Bearer ${token}`
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    return config
  },
  (error) => Promise.reject(error),
)

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const requestUrl = error.config?.url ?? ''
    if (
      error.response?.status === 401 &&
      !isLoginRequest(requestUrl) &&
      !isRefreshTokenRequest(requestUrl) &&
      !error.config?._tokenRefreshRetry
    ) {
      error.config._tokenRefreshRetry = true
      const token = await refreshActiveToken({ force: true })
      if (token) {
        error.config.headers = error.config.headers ?? {}
        error.config.headers.Authorization = `Bearer ${token}`
        return apiClient(error.config)
      }

      forceLogout()
    }
    return Promise.reject(error)
  },
)

export default apiClient
